interface FlechaProps {
  color?: string;
  w?: string;
  h?: string;
}

const Flecha = (props: FlechaProps) => {
  const { color, w, h } = props;

  return (
    <svg
      width={w ? w : '13'}
      height={h ? h : '11'}
      viewBox="0 0 13 11"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M7.125 1.125L11.5 5.5L7.125 9.875M1.5 5.5H11.5H1.5Z"
        stroke={color ? color : '#36B7E8'}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default Flecha;
